export default {
  courses: [],
  course: {},
  categories: [],
  lastLessons: []
};
